import { graphql } from '@apollo/client/react/hoc';
import * as React from 'react';
import BoxBody from 'components/BoxBody';
import Dialog from 'components/Dialog';
import ModalMenuItem from 'components/ModalMenuItem';
import TextWithIcon from 'components/TextWithIcon';
import Group from 'entities/Group';
import UserPreferredLanguageForm from 'settings/components/UserPreferredLanguageForm';
import SET_LANGUAGE_FOR_USER_MUTATION from 'users/components/UsersProfile/mutations/SetLanguageForUser.gql';

const withUserLanguageMutation = graphql(SET_LANGUAGE_FOR_USER_MUTATION);
const UserLanguageSelect: any = withUserLanguageMutation(UserPreferredLanguageForm as any);

type Props = {
  menuKey: string;
  userUuid: string;
  organization?: {
    id: number;
    uuid: string;
    name: string;
  };
  groupToAdmin?: Group;
  onUserUpdate?: (eventName?: string) => Promise<void>;
  canUpdatePreferredLanguage?: boolean;
  preferredLanguage?: string;
};

function PreferredLanguageModal(props: Props) {
  const {
    menuKey,
    userUuid,
    organization,
    groupToAdmin,
    onUserUpdate = () => {},
    canUpdatePreferredLanguage,
    preferredLanguage = '',
  } = props;

  if (!canUpdatePreferredLanguage) {
    return <span />;
  }

  const languageModal = (
    <Dialog title="Preferred language" size="small">
      <BoxBody divided size="small">
        <UserLanguageSelect
          userUuid={userUuid}
          targetUuid={organization?.uuid ?? groupToAdmin?.getUuid()}
          targetType={organization ? 'organization' : 'group'}
          preferredLanguage={preferredLanguage}
          onPreferredLanguageUpdated={() => onUserUpdate('user_profile.preferred_language.updated')}
          hideHeader
          full
        />
      </BoxBody>
    </Dialog>
  );

  return (
    <ModalMenuItem menuKey={menuKey} modal={languageModal} disabled={!canUpdatePreferredLanguage}>
      <TextWithIcon
        icon="globe-stroked"
        color="graphite"
        iconColor="graphite"
        iconSize="medium"
        size="xsmall"
      >
        Edit preferred language
      </TextWithIcon>
    </ModalMenuItem>
  );
}

export default PreferredLanguageModal;
